export enum AppModels {
    Custom = 1,
    Simple = 2,
    Group = 3,
    External = 4,
}
